// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2296":"941c99c6","3413":"caaa646b","4743":"9b557737","4840":"98e2dc04","6983":"3c38ee57"}[chunkId] + ".chunk.css";
};